import axios from "axios"

export default {
    namespaced: true,

    state: {
        blogs: []
    },
    mutations: {
        setBlogs(state, array){
            state.blogs = array
        }
    },
    actions: {
        fetchData(context, payload){
            let lang = payload.lang
            axios({
                method: "post",
                data: {
                    query: `query($lang:[String]){
                        inspirations: entries(section: "inspirations", site: $lang){
                            id,
                            title,
                            slug
                            ... on inspirations_inspirations_Entry {
                                lead,
                                image {
                                    id,
                                    url
                                },
                                video,
                                contentMatrix {
                                    ... on contentMatrix_textblock_BlockType {
                                        text
                                    }
                                }
                            }
                        }
                    }`,
                    variables: {
                        lang
                    }
                }
            }).then(function(res){
                context.commit('setBlogs', res.data.data.inspirations)
            })
        }
    },
    getters: {}
}
